<template>
  <div class="container">
    <el-form ref="form" :model="form">
       <el-form-item label="标题">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      <div class="part">今日数据</div>
      <div class="flex">
        <el-form-item label="成人">
          <el-input v-model.number="form.ageData[0].value"></el-input>
        </el-form-item>
        <el-form-item label="青少年">
          <el-input v-model.number="form.ageData[1].value"></el-input>
        </el-form-item>
        <el-form-item label="男">
          <el-input v-model.number="form.sexData[0].value"></el-input>
        </el-form-item>
        <el-form-item label="女">
          <el-input v-model.number="form.sexData[1].value"></el-input>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="历史预约教练总数">
          <el-input v-model.number="form.coachCount.total"></el-input>
        </el-form-item>
        <el-form-item label="今日预约教练总数">
          <el-input v-model.number="form.coachCount.today"></el-input>
        </el-form-item>
        <el-form-item label="今日预约数">
          <el-input v-model.number="form.userCount.today"></el-input>
        </el-form-item>
        <el-form-item label="当前使用">
          <el-input v-model.number="form.userCount.cur"></el-input>
        </el-form-item>
      </div>
      <div class="part">统计数据</div>
      <div class="flex">
        <el-form-item label="">
          <el-input
            v-for="(n, i) in form.topData"
            :key="i"
            placeholder="请输入内容"
            v-model.number="n.value"
          >
            <template slot="prepend">{{ n.name }}</template>
          </el-input>
        </el-form-item>
      </div>
       <div class="part">上课统计</div>
      <div class="flex">
        <el-form-item label="">
          <el-input
            v-for="(n, i) in form.classData"
            :key="i"
            placeholder="请输入内容"
            v-model.number="n.value"
          >
            <template slot="prepend">{{ n.name }}</template>
          </el-input>
        </el-form-item>
      </div>
       <div class="part">今日预约</div>
      <div class="flex">
        <el-form-item label="">
          <el-input
            v-for="(n, i) in form.appoData"
            :key="i"
            placeholder="请输入内容"
            v-model.number="n.value"
          >
            <template slot="prepend">{{ n.name }}</template>
          </el-input>
        </el-form-item>
      </div>
      <div class="flex">
        <el-form-item label="">
          <el-input
            v-for="(n, i) in form.incomeData"
            :key="i"
            placeholder="请输入内容"
            v-model.number="n.value"
          >
            <template slot="prepend">{{ n.name }}</template>
          </el-input>
        </el-form-item>
      </div>

      <div class="part">教室使用收入数据</div>
      <i class="el-icon-plus" @click="form.roomData.push({name:'',use:0,income:0})"></i>
      <div class="grid-box" v-for="(n, i) in form.roomData" :key="i">
        <el-input placeholder="请输入内容" v-model="n.name"> </el-input>
        <el-input placeholder="请输入内容" v-model="n.use">
          <template slot="prepend">使用次数</template>
        </el-input>
        <el-input placeholder="请输入内容" v-model="n.income">
          <template slot="prepend">今日收入</template>
        </el-input>
        <i class="el-icon-delete" @click="form.roomData.splice(i,1)"></i>
      </div>

      <div class="part">教室人流量数据</div>
        <i class="el-icon-plus" @click="form.roomPersonData.push({name:'',user:0,coach:0})"></i>
      <div
        class="grid-box"
        v-for="(n, i) in form.roomPersonData"
        :key="i + 'p'"
      >
        <el-input placeholder="请输入内容" v-model="n.name"> </el-input>
        <el-input placeholder="请输入内容" v-model="n.user">
          <template slot="prepend">用户数量</template>
        </el-input>
        <el-input placeholder="请输入内容" v-model="n.coach">
          <template slot="prepend">教练数量</template>
        </el-input>
          <i class="el-icon-delete" @click="form.roomPersonData.splice(i,1)"></i>
      </div>

      <div class="part">各时间段预约人数数据</div>

      <div>
        <div class="flex">
          <el-form-item label="各时间段预约人数">
            <div class="flex">
              <el-tag
                v-for="(tag, i) in form.timeCountData"
                @close="closeTag('timeCountData', i)"
                :key="i"
                closable
              >
                {{ tag.hour }}：用户{{ tag.count }}，教练{{ tag.count2 }}
              </el-tag>
            </div>
          </el-form-item>
        </div>
        <el-popover placement="right" width="400" trigger="click">
          <el-form>
            <el-form-item label="时间">
              <el-time-select
                v-model="hour"
                :picker-options="{
                  start: '06:00',
                  step: '01:00',
                  end: '23:00',
                }"
                placeholder="选择时间"
              >
              </el-time-select>
            </el-form-item>
            <el-form-item label="用户">
              <el-input v-model.number="count" placeholder="数量"></el-input>
            </el-form-item>
            <el-form-item label="教练">
              <el-input v-model.number="count2" placeholder="数量"></el-input>
            </el-form-item>
            <el-button @click="addToday('timeCountData')">确定</el-button>
          </el-form>
          <el-button type="primary" slot="reference">添加数据</el-button>
        </el-popover>
      </div>

      <div class="part">热门教室预约人数图表</div>
      <div>
        <div class="flex">
          <el-form-item label="热门教室预约人数,5条">
            <div class="flex">
              <el-tag
                v-for="(tag, i) in form.areaTopBarData"
                @close="closeTag('areaTopBarData', i)"
                :key="i"
                closable
              >
                {{ tag.name }}:{{ tag.value }}
              </el-tag>
            </div>
          </el-form-item>
        </div>
        <el-popover placement="right" width="400" trigger="click">
          <el-form>
            <el-form-item label="教室">
              <el-input
                v-model="name"
                placeholder="参考上方教室"
              ></el-input>
            </el-form-item>
            <el-form-item label="人数">
              <el-input v-model.number="count" placeholder="数量"></el-input>
            </el-form-item>
            <el-button @click="addBar('areaTopBarData')">确定</el-button>
          </el-form>
          <el-button type="primary" slot="reference">添加数据</el-button>
        </el-popover>
      </div>

      <div class="part">热门教室收入图表</div>
      <div>
        <div class="flex">
          <el-form-item label="热门教室收入，5条">
            <div class="flex">
              <el-tag
                v-for="(tag, i) in form.incomeTopBarData"
                @close="closeTag('incomeTopBarData', i)"
                :key="i"
                closable
              >
                {{ tag.name }}:{{ tag.value }}
              </el-tag>
            </div>
          </el-form-item>
        </div>
        <el-popover placement="right" width="400" trigger="click">
          <el-form>
            <el-form-item label="教室">
              <el-input
                v-model="name"
                placeholder="参考上方教室"
              ></el-input>
            </el-form-item>
            <el-form-item label="人数">
              <el-input v-model.number="count" placeholder="数量"></el-input>
            </el-form-item>
            <el-button @click="addBar('incomeTopBarData')">确定</el-button>
          </el-form>
          <el-button type="primary" slot="reference">添加数据</el-button>
        </el-popover>
      </div>
      <div class="m-t20">
        <el-button v-if="id" type="success" @click="update">修改数据</el-button>
        <el-button v-else type="warning" @click="add">新增数据</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: "",
      time: "",
      city: "杭州市",
      count: 0,
      count2: 0,
      hour: "",
      name: "",
      form: {
        name:'',
        ageData: [
          {
            name: "成人",
            value: 10,
          },
          {
            name: "青少年",
            value: 20,
          },
        ],
        sexData: [
          {
            name: "男",
            value: 12,
          },
          {
            name: "女",
            value: 18,
          },
        ],
        coachCount: {
          total: 156,
          today: 14,
        },
        userCount: {
          today: 30,
          cur: 12,
        },
        //顶部数据
        topData: [
          {
            name: "当前使用教室",
            value: 3,
          },
          {
            name: "今日预约人数",
            value: 132,
          },
          {
            name: "今日课程数量",
            value: 35,
          },
          {
            name: "已上课课程",
            value: 12,
          },
        ],
        //收入数据
        incomeData: [
          {
            name: "总收入(元)",
            value: 0,
          },
          {
            name: "今日收入(元)",
            value: 0,
          },
          {
            name: "今年收入",
            value: 0,
          },
        ],
        //上课数量
        classData: [
          {
            name: "已上课程",
            value: 3,
          },
          {
            name: "待上课程",
            value: 2,
          },
          {
            name: "未上课程",
            value: 1,
          },
        ],
        //今日预约
        appoData: [
          {
            name: "总预约",
            value: 6,
          },
          {
            name: "今日已核销",
            value: 4,
          },
          {
            name: "今日待核销",
            value: 2,
          },
        ],
        areaTopBarData: [
          {
            name: "健身房",
            value: 10,
          },
        ],
        incomeTopBarData: [
          {
            name: "健身房",
            value: 200,
          },
        ],
        roomData: [
          {
            name: "健身房",
            use: 0,
            income: 0,
          },
          {
            name: "瑜伽教室",
            use: 0,
            income: 0,
          },
          {
            name: "艺术教室",
            use: 0,
            income: 0,
          },
          {
            name: "文化教室",
            use: 0,
            income: 0,
          },
          {
            name: "篮球场",
            use: 0,
            income: 0,
          },
          {
            name: "体适能教室",
            use: 0,
            income: 0,
          },
          {
            name: "轮滑教室",
            use: 0,
            income: 0,
          },
          {
            name: "武术教室",
            use: 0,
            income: 0,
          },
          {
            name: "游玩区",
            use: 0,
            income: 0,
          },
          {
            name: "交流中心",
            use: 0,
            income: 0,
          },
        ],

        timeCountData: [{ hour: "12:00", count: 10, count2: 10 }],
        roomPersonData: [
          {
            name: "健身房",
            user: 0,
            coach: 0,
          },
          {
            name: "瑜伽教室",
            user: 0,
            coach: 0,
          },
          {
            name: "艺术教室",
            user: 0,
            coach: 0,
          },
          {
            name: "文化教室",
            user: 0,
            coach: 0,
          },
          {
            name: "篮球场",
            user: 0,
            coach: 0,
          },
          {
            name: "体适能教室",
            user: 0,
            coach: 0,
          },
          {
            name: "轮滑教室",
            user: 0,
            coach: 0,
          },
          {
            name: "武术教室",
            user: 0,
            coach: 0,
          },
        ],
      },
    };
  },

  mounted() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getInfo();
    }
  },

  methods: {
    getInfo() {
      this.$axios({
        url: "/user/sysParam/findById",
        params: {
          id: this.$route.query.id,
        },
      }).then((res) => {
        let v = res.data.data;
        this.form = JSON.parse(v.param_value);
        this.city = v.remark;
        this.time = v.update_time.split(" ")[0];
      });
    },
    closeTag(v, i) {
      this.form[v].splice(i, 1);
    },
    addBar(v) {
      this.form[v].push({
        value: Number(this.count),
        name: this.name,
      });
    },
    addToday(v) {
      this.form[v].push({
        hour: this.hour,
        count: Number(this.count),
        count2: Number(this.count2),
      });
    },
    update() {
      this.$axios({
        url: "/user/sysParam/update",
        method: "post",
        data: {
          id: this.id,
          param_key: "space_data_v",
          param_value: JSON.stringify(this.form),
          type: "spaceData",
        },
      }).then((res) => {
        this.$router.back();
      });
    },
    add() {
      this.$axios({
        url: "/user/sysParam/insert",
        method: "post",
        data: {
          param_key: "space_data_v",
          param_value: JSON.stringify(this.form),
          type: "spaceData",
        },
      }).then((res) => {
        this.$router.back();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.flex {
  display: flex;
}
.part {
  font-size: 16px;
  height: 30px;
  font-weight: 600;
}
</style>